import React from 'react';
import './Loader.css';  

const NIDSLoader = () => {
  return (
    <div className="loader">

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 120"
        className="shield"
      >
        <defs>
          <linearGradient id="shieldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="red" />
            <stop offset="100%" stopColor="#6366f1" />
          </linearGradient>
        </defs>
        <path
          d="M50 5 L95 25 L95 60 Q95 90 50 115 Q5 90 5 60 L5 25 Z"
          fill="url(#shieldGradient)"
          stroke="#c7d2fe"
          strokeWidth="2"
        />
        <path
          d="M50 20 L80 35 L80 60 Q80 80 50 100 Q20 80 20 60 L20 35 Z"
          fill="#ffffff"
          fillOpacity="0.1"
        />
    
        <circle cx="30" cy="40" r="3" fill="#e0e7ff" />
        <circle cx="70" cy="40" r="3" fill="#e0e7ff" />
        <circle cx="50" cy="70" r="3" fill="#e0e7ff" />
        <circle cx="30" cy="100" r="3" fill="#e0e7ff" />
        <circle cx="70" cy="100" r="3" fill="#e0e7ff" />

       
        <line x1="30" y1="40" x2="70" y2="40" stroke="#e0e7ff" strokeWidth="1" />
        <line x1="30" y1="40" x2="50" y2="70" stroke="#e0e7ff" strokeWidth="1" />
        <line x1="70" y1="40" x2="50" y2="70" stroke="#e0e7ff" strokeWidth="1" />
        <line x1="30" y1="40" x2="30" y2="100" stroke="#e0e7ff" strokeWidth="1" />
        <line x1="70" y1="40" x2="70" y2="100" stroke="#e0e7ff" strokeWidth="1" />
        <line x1="50" y1="70" x2="30" y2="100" stroke="#e0e7ff" strokeWidth="1" />
        <line x1="50" y1="70" x2="70" y2="100" stroke="#e0e7ff" strokeWidth="1" />

     
        <circle className="packet" r="3" fill="#4ade80">
          <animateMotion
            path="M30 40 L70 40 L50 70 L30 100 L70 100 L50 70 L70 40"
            dur="2s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>

      <p className="statusText" style={{marginTop:'50px',textAlign:'center'}}><strong>Showcasing NIDS :</strong> A Secure Network Future</p>
      <div className="statusDots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default NIDSLoader;
